<template>
  <v-app>
    <!-- <v-navigation-drawer temporary v-model="sideNav">
      <v-list>
        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer> -->
    <v-toolbar dark style="background-color: #5390cc" fixed>
      <!-- <v-toolbar-side-icon
        @click.stop="sideNav = !sideNav"
        class="hidden-sm-and-up "></v-toolbar-side-icon> -->
        <router-link v-if="this.$router.currentRoute.name != 'Home'" to="/" tag="span" style="cursor: pointer; margin-left: 0px"><v-icon style="font-size: 45px; color: white; margin-right: -10px;">keyboard_arrow_left</v-icon></router-link>
      <v-list-tile-avatar>
        <img src='/static/doc-images/lists/cropped-circle.png'/>
      </v-list-tile-avatar>
      <v-toolbar-title>
        <router-link to="/" tag="span" style="cursor: pointer">Avatar Meher Baba</router-link>
        <router-link to="/" tag="span" style="cursor: pointer; font-size: 0.45em;">Avatar Meher Baba Perpetual Public Charitable Trust</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <amp-ad
        type="system"
        data-param-text="Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App"
        data-param-url="https://ambshare.page.link/Zi7X">
      </amp-ad>
      <v-btn @click="appShare()" icon style="float: right !important">
        <v-icon>share</v-icon>
      </v-btn> -->
      <v-dialog v-if="this.$router.currentRoute.name == 'Home'" v-model="dialog" persistent max-width="290">
        <v-btn slot="activator" icon style="float: right !important">
        <v-icon>share</v-icon>
      </v-btn> 
        <v-card>
          <v-card-title class="headline">Share With</v-card-title>
          <v-card-text>
            <social-sharing url="https://ambshare.page.link/Zi7X" title="Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App" inline-template>
              <div>
                <v-layout>
                  <v-flex xs-4>
                    <network network="facebook">
                      <div style="text-align:center; padding-left:5px">
                        <img src="/static/img/icons/Fb.png" height="35px" width="35px" ><br>
                        <h5>Facebook</h5>
                      </div>
                    </network>
                  </v-flex>
                  <v-flex xs-4>
                    <network network="sms">
                      <div style="text-align:center; padding-left:5px">
                        <img src="/static/img/icons/message.png" height="35px" width="35px"><br>
                        <h5>SMS</h5>
                      </div>
                    </network>
                  </v-flex>
                  <v-flex xs-4>
                    <network network="whatsapp">
                      <div style="text-align:center; padding-left:5px">
                        <img src="/static/img/icons/whatsapp.png" height="35px" width="35px"><br>
                        <h5>WhatsApp</h5>
                      </div>
                    </network>
                  </v-flex>
                </v-layout>
                <br>
                <v-layout>
                  <v-flex xs-4>
                    <network network="email">
                      <div style="text-align:center; padding-left:5px">
                        <img src="/static/img/icons/email.png" height="35px" width="35px"><br>
                        <h5>Email</h5>
                      </div>
                    </network>
                  </v-flex>
                </v-layout>
              </div>
            </social-sharing>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="dialog = false">Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          flat
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <main v-if="timeOut">
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        timeOut: false,
        dialog: false,
        sideNav: false
      }
    },
    created () {
      setTimeout(() => {
        this.timeOut = true
      }, 1000)
    },
    computed: {
      menuItems () {
        let menuItems = [
          { icon: 'home', title: 'Home', link: '/' }
          // {icon: 'face', title: 'Sign up', link: '/signup'},
          // {icon: 'lock_open', title: 'Sign in', link: '/login'}
        ]
        if (this.userIsAuthenticated) {
          menuItems = [
            { icon: 'home', title: 'Home', link: '/' },
            // {icon: 'receipt', title: 'Token', link: '/changeToken'},
            {icon: 'event_note', title: 'Update Events', link: '/update'}
          ]
        }
        return menuItems
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },
    methods: {
      appShare: function () {
        if (navigator.share) {
          navigator.share({
            title: 'AMBPPCT',
            text: 'Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App',
            url: 'https://ambshare.page.link/Zi7X'
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error))
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>

<style>
  .toolbar__title {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: unset;
  }
</style>


// WEBPACK FOOTER //
// App.vue?f19d968a